var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { trapEvent } from "../../utils/EventHelpers";
import Flex from "../box/Flex";
import Spinner from "../loader/Spinner";
import { StyledPaginationContainer, StyledLoadMoreButton } from "./LoadMoreButton.style";
import { useNxTranslation } from "../../i18n/useNxTranslation";
import translationEN from "./locales/translation-en.json";
import translationFR from "./locales/translation-fr.json";
const LoadMoreButton = (_a) => {
    var { id, "data-insights": insightsAttr, isLoading = false, onClick } = _a, rest = __rest(_a, ["id", "data-insights", "isLoading", "onClick"]);
    const { t, nxI18n } = useNxTranslation();
    nxI18n.addResources("en", "table", translationEN);
    nxI18n.addResources("fr", "table", translationFR);
    const handleLoadMoreClicked = (e) => {
        trapEvent(e);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (React.createElement(StyledPaginationContainer, null,
        isLoading && (React.createElement(Flex, { position: "absolute", alignItems: "center", justifyContent: "center", top: "0px", right: "0px", bottom: "0px", left: "0px" },
            React.createElement(Spinner, { size: "body" }))),
        React.createElement(StyledLoadMoreButton, Object.assign({ id: id, "data-insights": insightsAttr, isVisible: !isLoading, "aria-label": t("loadMore", { ns: "table" }), onClick: handleLoadMoreClicked }, rest), t("loadMore", { ns: "table" }))));
};
export default LoadMoreButton;
//# sourceMappingURL=LoadMoreButton.js.map